export const getAdMethods = (player) => ({
  adSkip: () => player.emit('ad:skin:skipMessage'),
  adClose: () => player.emit('ad:skin:skipButton'),
  adSetVolume: (level) => player.emit('ad:skin:volumeChanged', level),
  adMute: () => player.emit('ad:skin:muteChanged', true),
  adUnMute: () => player.emit('ad:skin:muteChanged', false),
  adClickOnBg: (url, overlay = false) => {
    if (url) window.open(url, '_blank');
    player.emit('ad:skin:clickOnBg', { isOverlay: overlay });
  },
  adClickMessage: (url) => {
    if (url) window.open(url, '_blank');
    player.emit('ad:skin:clickOnMessage');
  },
  adResume: () => player.emit('ad:skin:resume'),
  adPause: () => player.emit('ad:skin:pause'),
});
